/**
 * Shared warn-log messages for the "no provider found" empty-data path.
 *
 * These strings are a contract between the producers (ProviderHttpService,
 * ProviderStore) and their specs, and they key Datadog log queries / monitors
 * used to verify the empty-data path stays observable after MER-4838. Keep them
 * in one place so producer, test, and any DD facet reference one source of truth.
 */
export const ProviderLogMessages = {
  FETCH_BY_ACCOUNT_UUID_EMPTY: 'Provider not found for fetchByAccountUuid',
  PERSONA_PROVIDER_ID_EMPTY: 'No provider found for persona_provider_id'
} as const;
